import { createContext, useContext } from "react";

export interface SmartAppContextValue {
    stickyActionBar: boolean;
}

const defaultValue: SmartAppContextValue = {
    stickyActionBar: false,
};

export const SmartAppContext = createContext<SmartAppContextValue>(defaultValue);

export const useSmartAppContext = () => useContext(SmartAppContext);
